export const LOAD_USER_FOLDERS = "LOAD_USER_FOLDERS";
export const GET_USER_FOLDERS_SUCCESS = "GET_USER_FOLDERS_SUCCESS";
export const GET_USER_FOLDERS_FAILED = "GET_USER_FOLDERS_FAILED";
export const CHANGE_FOLDERS_SORT = "CHANGE_FOLDERS_SORT";
export const CHANGE_FOLDERS_PAGE = "CHANGE_FOLDERS_PAGE";
export const UPDATE_FOLDERS_LIMIT = "UPDATE_FOLDERS_LIMIT";
export const ENABLE_FOLDER_LOADER = "ENABLE_FOLDER_LOADER";
export const POST_FOLDER = "POST_FOLDER";
export const POST_FOLDER_SUCCESS = "POST_FOLDER_SUCCESS";
export const UPDATE_FOLDER = "UPDATE_FOLDER";
export const UPDATE_FOLDER_SUCCESS = "UPDATE_FOLDER_SUCCESS";
export const DELETE_FOLDER = "DELETE_FOLDER";
export const DELETE_FOLDER_SUCCESS = "DELETE_FOLDER_SUCCESS";
export const LOAD_ALL_USER_FOLDERS = "LOAD_ALL_USER_FOLDERS";
export const GET_ALL_USER_FOLDERS_SUCCESS = "GET_ALL_USER_FOLDERS_SUCCESS";
export const GET_ALL_USER_FOLDERS_FAILED = "GET_ALL_USER_FOLDERS_FAILED";
export const MANAGE_CALCULS_FOLDERS = "MANAGE_CALCULS_FOLDERS";
export const MANAGE_CALCULS_FOLDERS_SUCCESS = "MANAGE_CALCULS_FOLDERS_SUCCESS";
export const MANAGE_CALCULS_FOLDERS_FAILED = "MANAGE_CALCULS_FOLDERS_FAILED";
export const CHANGE_FOLDER_CALCULS_SORT = "CHANGE_FOLDER_CALCULS_SORT";
export const CHANGE_FOLDER_CALCULS_PAGE = "CHANGE_FOLDER_CALCULS_PAGE";
export const UPDATE_FOLDER_CALCULS_LIMIT = "UPDATE_FOLDER_CALCULS_LIMIT";
export const LOAD_FOLDER_CALCULS = "LOAD_FOLDER_CALCULS";
export const GET_FOLDER_CALCULS_SUCCESS = "GET_FOLDER_CALCULS_SUCCESS";
export const GET_FOLDER_CALCULS_FAILED = "GET_FOLDER_CALCULS_FAILED";
export const GET_FOLDER = "GET_FOLDER";
export const GET_FOLDER_SUCCESS = "GET_FOLDER_SUCCESS";
export const GET_FOLDER_FAILED = "GET_FOLDER_FAILED";
export const GET_ARCHIVED_CALCULS = "GET_ARCHIVED_CALCULS";
export const GET_ARCHIVED_CALCULS_SUCCESS = "GET_ARCHIVED_CALCULS_SUCCESS";
export const GET_ARCHIVED_CALCULS_FAILED = "GET_ARCHIVED_CALCULS_FAILED";
export const CHANGE_FOLDER_CALCULS_SEARCH = "CHANGE_FOLDER_CALCULS_SEARCH";
export const UPDATE_FOLDER_CALCULS_FILTERS = "UPDATE_FOLDER_CALCULS_FILTERS";
export const CLEAR_FOLDER_INFOS = "CLEAR_FOLDER_INFOS";
